import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Grid2,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import Divider from "@mui/material/Divider";
// import DialogActions from "@mui/material/DialogActions";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
import { Icons } from "../../../../config/MuiIcons.config";
import AppInputField from "../../../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../../../components/CommonReusableComponent/AppButton/AppButton";
import MUIErrorText from "../../../../components/MUIErrorText/MUIErrorText";
import CountryCodeDropdown from "../../../../components/CommonReusableComponent/CountryCodeDropdown/CountryCodeDropdown";
import ImagePreview from "../../../../common/ImagePreview/ImagePreview";
import ImageThumbnail from "../../../../common/ImageThumbnail/ImageThumbnail";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  createNewCompanyAccount,
  // updateExistingCompanyAccount,
} from "../../../../helpers/api-functions-helper";
import { useSnackbar } from "../../../../contexts/Snackbar.context";
import { useBackdrop } from "../../../../contexts/BackDrop.context.js";
import {
  checkDuplicateEntity,
  // replaceTextToCaplitalize,
  generateRandomId,
  validateEmailField,
  // sortData
} from "../../../../common/CommonFunctions";
import { uploadImageHandler } from "../../../../common/UploadImage/uploadImageHandler";
import { CLOUD_STOAGE } from "../../../../config/CloudStorage.config";
import {
  APP_MESSAGE,
  SNACKBAR_VARIANT,
  FORM_VALIDATIONS,
  USE_FORMIK_SCHEMA,
  ERROR_MESSAGE,
} from "../../../../config/Messages.config.js";
import noImage from "../../../../assets/images/image_placeholder.svg";
import { AppTheme } from "../../../../theme/App.theme";

const CreateNewOrUpdateAccountModal = ({
  Open,
  Title,
  DialogData,
  SetDialogData,
  ToggleDialogBox,
  DialogType,
  FetchAllCompaniesInfo,
  AllCompanyName,
}) => {
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  // const isUpdateMode = DialogType === "Update" ? true : false;
  const isViewMode = DialogType === "View" ? true : false;
  // Company logo state
  const [image_url, setImage_Url] = useState(null);
  const [file, setFile] = useState(null);
  const [imageUploadError, setImageUploadError] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [previewImage, setPreviewImage] = useState({
    isVisible: false,
    image: null,
  });

  // Function used to create new role
  const createNewAccount = (data) => {
    showBackdrop();
    createNewCompanyAccount(data)
      .then((res) => {
        if (res && res.data) {
          const { statusCode, success, message, data } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.ACCOUNT_MASTER.CREATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.ACCOUNT_MASTER.CREATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleResetDialogBox();
            FetchAllCompaniesInfo();
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.ACCOUNT_MASTER.CREATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        hideBackdrop();
      });
  };

  // Function used to update existing role
  // const updateExistingAccount = (data) => {
  //   setIsCreateOrUpdateClicked(true);
  //   updateExistingCompanyAccount(data)
  //     .then((res) => {
  //       if (res && res.data) {
  //         const { statusCode, success, message, data } = res.data;
  //         if (!success && statusCode !== 200) {
  //           showSnackbar(
  //             data || message || APP_MESSAGE.ACCOUNT_MASTER.UPDATE.FAILED,
  //             SNACKBAR_VARIANT.ERROR
  //           );
  //         } else {
  //           showSnackbar(
  //             APP_MESSAGE.ACCOUNT_MASTER.UPDATE.SUCCESS,
  //             SNACKBAR_VARIANT.SUCCESS
  //           );
  //           handleResetDialogBox();
  //           FetchAllCompaniesInfo();
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error: ", error);
  //       showSnackbar(
  //         APP_MESSAGE.ACCOUNT_MASTER.UPDATE.FAILED,
  //         SNACKBAR_VARIANT.ERROR
  //       );
  //     })
  //     .finally(() => {
  //       setIsCreateOrUpdateClicked(false);
  //     });
  // };

  const UploadImageToFirebase = () => {
    return new Promise((resolve, reject) => {
      setIsImageUploading(true);
      showBackdrop();
      setImageUploadError("");
      var firebaseImageName = `image-${generateRandomId(20)}.${
        file?.name.split(".")[1]
      }`;
      var image_storagePath = CLOUD_STOAGE.ACCOUNT_MASTER;
      uploadImageHandler(
        image_storagePath,
        firebaseImageName,
        file,
        (url) => {
          resolve(url);
          setImage_Url(url);
        },
        setIsImageUploading,
        (status) => {
          if (status.isError) {
            reject(new Error(status.message));
            hideBackdrop();
          }
        },
        () => setFile(null)
      );
    });
  };

  // Function to handle the complete flow: upload image and then create/update PPE
  const handleSubmitForm = async (values) => {
    try {
      let firebase_URL = image_url;
      if (file && firebase_URL?.includes("blob")) {
        firebase_URL = await UploadImageToFirebase();
      }

      if (firebase_URL) {
        const payload = {
          ...values,
          abbreviation: values.abbreviation.trim(),
          name: values.name.trim(),
          spocPerson: values.spocPerson.trim(),
          superAdminUserName: values.superAdminUserName.trim(),
          address: values.address.trim(),
          logo: firebase_URL,
          // superAdminPhoneNumberContryCode: values.phoneNumberCountryCode,
        };
        if (checkDuplicateEntity(AllCompanyName, values.name)) {
          showSnackbar(
            APP_MESSAGE.ACCOUNT_MASTER.DUPLICATE_ACCOUNT_NAME,
            SNACKBAR_VARIANT.ERROR
          );
        }
        // console.log("payload: ", payload);
        createNewAccount(payload);
      }
    } catch (error) {
      console.error("Image upload failed: ", error);
      showSnackbar(
        error.message || APP_MESSAGE.COMPANY_MASTER.LOGO_UPLOAD.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    }
  };

  // Function used to handle select image input
  const handleChangeImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      var u = URL.createObjectURL(file);
      var img = new Image();
      img.src = u;
      setFile(file);
      setImage_Url(u);
      setImageUploadError("");
    }
  };

  // Formik form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (DialogData && DialogData.name) || "",
      address: (DialogData && DialogData.address) || "",
      phoneNumberCountryCode:
        (DialogData && DialogData.phoneNumberCountryCode) || "",
      phoneNumber: (DialogData && DialogData.phoneNumber) || "",
      email: (DialogData && DialogData.email) || "",
      superAdminUserName: (DialogData && DialogData.superAdminUserName) || "",
      superAdminPhoneNumberContryCode:
        (DialogData && DialogData.superAdminPhoneNumberContryCode) || "",
      superAdminPhoneNumber:
        (DialogData && DialogData.superAdminPhoneNumber) || "",
      superAdminEmailId: (DialogData && DialogData.superAdminEmailId) || "",
      spocPerson: (DialogData && DialogData.spocPerson) || "",
      abbreviation: (DialogData && DialogData.abbreviation) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.TEXT_INPUT.REGEX.INITIAL,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.NAME),
      email: Yup.string()
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.EMAIL)
        // .email(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.EMAIL),
        .test("email-validation", "Invalid email", function (value) {
          if (!value) {
            return this.createError({ message: "Email is required" });
          }
          const validationMessage = validateEmailField(value);
          return validationMessage === true
            ? true
            : this.createError({ message: validationMessage });
        }),
      abbreviation: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.UNIQUE_PREFIX.REGEX,
          FORM_VALIDATIONS.UNIQUE_PREFIX.MESSAGE
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.ABBRIVATIONS),
      spocPerson: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.TEXT_INPUT.REGEX.INITIAL,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.COORDINATOR_NAME),
      phoneNumber: Yup.string()
        .matches(
          FORM_VALIDATIONS.NUMBER_INPUT.REGEX,
          FORM_VALIDATIONS.NUMBER_INPUT.MESAAGE
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.COORDINATOR_NUMBER),
      phoneNumberCountryCode: Yup.string().required(
        USE_FORMIK_SCHEMA.ACCOUNT_MASTER.COUNTRY_CODE
      ),
      superAdminPhoneNumberContryCode: Yup.string().required(
        USE_FORMIK_SCHEMA.ACCOUNT_MASTER.COUNTRY_CODE
      ),
      address: Yup.string()
        .trim()
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.ADDRESS),
      superAdminUserName: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.TEXT_INPUT.REGEX.INITIAL,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.SUPERADMIN_NAME),
      superAdminEmailId: Yup.string()
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.SUPERADMIN_EMAIL)
        // .email(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.SUPERADMIN_EMAIL),
        .test("email-validation", "Invalid email", function (value) {
          if (!value) {
            return this.createError({ message: "Email is required" });
          }
          const validationMessage = validateEmailField(value);
          return validationMessage === true
            ? true
            : this.createError({ message: validationMessage });
        }),
      superAdminPhoneNumber: Yup.string()
        .matches(
          FORM_VALIDATIONS.NUMBER_INPUT.REGEX,
          FORM_VALIDATIONS.NUMBER_INPUT.MESAAGE
        )
        .required(USE_FORMIK_SCHEMA.ACCOUNT_MASTER.SUPERADMIN_NUMBER),
    }),
    onSubmit: (values) => {
      console.log("values: ", values);
      if (image_url !== null) {
        handleSubmitForm(values);
      } else {
        setImageUploadError("Please upload image");
      }
    },
  });

  // Function used reset dialog box
  function handleResetDialogBox() {
    ToggleDialogBox("Create/Update");
    validation.handleReset();
    SetDialogData({
      mode: "",
      data: null,
    });
  }

  return (
    <Dialog
      open={Open}
      disableEscapeKeyDown={true}
      maxWidth="md"
      disableEnforceFocus={true}
      fullWidth
      slotProps={{
        backdrop: {
          style: {
            opacity: 0.7,
          },
        }
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Typography
          className="inter-medium-500"
          style={{
            fontSize: "18px",
          }}
        >
          {Title}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleResetDialogBox}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Icons.Close />
      </IconButton>
      <DialogContent dividers>
        <div>
          {previewImage.isVisible && (
            <ImagePreview
              ImageUrl={previewImage.image}
              TogglePreview={() => {
                setPreviewImage((e) => ({
                  ...e,
                  isVisible: false,
                  image: null,
                }));
              }}
            />
          )}
          <Grid2 container spacing={2} className="mb-1">
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Company Name
              </Typography>
              <AppInputField
                Name={"name"}
                Id={"name"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.name || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                PlaceHolder={"Enter company name"}
                Error={
                  validation.touched.name && validation.errors.name
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.name && validation.errors.name ? (
                    <MUIErrorText ErrorMessage={validation.errors.name} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Company Email
              </Typography>
              <AppInputField
                Name={"email"}
                Id={"email"}
                Disabled={isViewMode}
                Type={"email"}
                Value={validation.values.email || ""}
                OnBlur={validation.handleBlur}
                OnChange={(e) => {
                  const { value, name } = e.target;
                  validation.handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: name,
                      value: value.toLowerCase(),
                    },
                  });
                }}
                PlaceHolder={"Enter company email"}
                Error={
                  validation.touched.email && validation.errors.email
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.email && validation.errors.email ? (
                    <MUIErrorText ErrorMessage={validation.errors.email} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Unique Prefix
              </Typography>
              <AppInputField
                Name={"abbreviation"}
                Id={"abbreviation"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.abbreviation || ""}
                OnBlur={validation.handleBlur}
                OnChange={(e) => {
                  const { value, name } = e.target;
                  validation.handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: name,
                      value: value.toUpperCase(),
                    },
                  });
                }}
                PlaceHolder={"Enter unique prefix"}
                Error={
                  validation.touched.abbreviation &&
                  validation.errors.abbreviation
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.abbreviation &&
                  validation.errors.abbreviation ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.abbreviation}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Coordinator (SPOC)
              </Typography>
              <AppInputField
                Name={"spocPerson"}
                Id={"spocPerson"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.spocPerson || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                PlaceHolder={"Enter coordinator name"}
                Error={
                  validation.touched.spocPerson && validation.errors.spocPerson
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.spocPerson &&
                  validation.errors.spocPerson ? (
                    <MUIErrorText ErrorMessage={validation.errors.spocPerson} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Country Code
              </Typography>
              <CountryCodeDropdown
                Id={"phoneNumberCountryCode"}
                Name={"phoneNumberCountryCode"}
                PlaceHolder={"Country code"}
                Disabled={isViewMode}
                Value={validation.values.phoneNumberCountryCode || ""}
                OnChange={validation.handleChange}
                OnBlur={validation.handleBlur}
                Error={
                  validation.touched.phoneNumberCountryCode &&
                  validation.errors.phoneNumberCountryCode
                    ? true
                    : false
                }
                HelperText={validation.errors.phoneNumberCountryCode}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Coordinator Contact Number
              </Typography>
              <AppInputField
                Name={"phoneNumber"}
                Id={"phoneNumber"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.phoneNumber || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                PlaceHolder={"Enter coordinator contact number"}
                Error={
                  validation.touched.phoneNumber &&
                  validation.errors.phoneNumber
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.phoneNumber &&
                  validation.errors.phoneNumber ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.phoneNumber}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 8 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Office Address
              </Typography>
              <AppInputField
                Name={"address"}
                Id={"address"}
                Type={"text"}
                IsMultiLine={true}
                Disabled={isViewMode}
                Value={validation.values.address || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                PlaceHolder={"Enter office address"}
                Error={
                  validation.touched.address && validation.errors.address
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.address && validation.errors.address ? (
                    <MUIErrorText ErrorMessage={validation.errors.address} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <div className="d-flex">
                <div>
                  <Typography
                    variant="body2"
                    className="inter-regular-400 py-2"
                  >
                    Company Logo
                  </Typography>
                  <input
                    type="file"
                    id="company-logo-input"
                    name="Image_URL"
                    accept="image/png, image/jpg, image/jpeg"
                    style={{ display: "none" }}
                    onChange={handleChangeImage}
                  />
                  <Link
                    href="#"
                    onClick={() => {
                      if (!isViewMode) {
                        var inputFile = document.querySelector(
                          "#company-logo-input"
                        );
                        inputFile.click();
                      } else {
                        setPreviewImage({
                          isVisible: true,
                          image:
                            !DialogData?.logo && !image_url
                              ? noImage
                              : image_url
                              ? image_url
                              : DialogData?.logo,
                        });
                      }
                    }}
                    className="inter-regular-400"
                    style={{
                      fontSize: "14px",
                      color: AppTheme.PRIMARY_COLOR,
                    }}
                  >
                    {isViewMode ? "Preview Image" : "Choose New Image"}
                  </Link>
                  <br />
                  {imageUploadError ? (
                    <MUIErrorText ErrorMessage={imageUploadError} />
                  ) : null}
                </div>
                <div className="ms-auto">
                  <ImageThumbnail
                    IsUsedForCompanyDetails={true}
                    ImageUrl={
                      !DialogData?.logo && !image_url
                        ? noImage
                        : image_url
                        ? image_url
                        : DialogData?.logo
                    }
                    OnClickHandler={() => {
                      if ((DialogData?.logo || image_url) && !isViewMode) {
                        setPreviewImage({
                          isVisible: true,
                          image:
                            !DialogData?.logo && !image_url
                              ? noImage
                              : image_url
                              ? image_url
                              : DialogData?.logo,
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </Grid2>
          </Grid2>
          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
            className="my-2"
          />
          <Grid2 container spacing={2} className="mb-1">
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Super Admin Name
              </Typography>
              <AppInputField
                Name={"superAdminUserName"}
                Id={"superAdminUserName"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.superAdminUserName || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                PlaceHolder={"Enter super admin name"}
                Error={
                  validation.touched.superAdminUserName &&
                  validation.errors.superAdminUserName
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.superAdminUserName &&
                  validation.errors.superAdminUserName ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.superAdminUserName}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Country Code
              </Typography>
              <CountryCodeDropdown
                Id={"superAdminPhoneNumberContryCode"}
                Name={"superAdminPhoneNumberContryCode"}
                PlaceHolder={"Country code"}
                Disabled={isViewMode}
                Value={validation.values.superAdminPhoneNumberContryCode || ""}
                OnChange={validation.handleChange}
                OnBlur={validation.handleBlur}
                Error={
                  validation.touched.superAdminPhoneNumberContryCode &&
                  validation.errors.superAdminPhoneNumberContryCode
                    ? true
                    : false
                }
                HelperText={validation.errors.superAdminPhoneNumberContryCode}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Super Admin Contact Number
              </Typography>
              <AppInputField
                Name={"superAdminPhoneNumber"}
                Id={"superAdminPhoneNumber"}
                Type={"text"}
                Disabled={isViewMode}
                Value={validation.values.superAdminPhoneNumber || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                PlaceHolder={"Enter super admin contact number"}
                Error={
                  validation.touched.superAdminPhoneNumber &&
                  validation.errors.superAdminPhoneNumber
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.superAdminPhoneNumber &&
                  validation.errors.superAdminPhoneNumber ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.superAdminPhoneNumber}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-1">
                Super Admin Email
              </Typography>
              <AppInputField
                Name={"superAdminEmailId"}
                Id={"superAdminEmailId"}
                Type={"email"}
                Disabled={isViewMode}
                Value={validation.values.superAdminEmailId || ""}
                OnBlur={validation.handleBlur}
                OnChange={(e) => {
                  const { value, name } = e.target;
                  validation.handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: name,
                      value: value.toLowerCase(),
                    },
                  });
                }}
                PlaceHolder={"Enter super admin email"}
                Error={
                  validation.touched.superAdminEmailId &&
                  validation.errors.superAdminEmailId
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.superAdminEmailId &&
                  validation.errors.superAdminEmailId ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.superAdminEmailId}
                    />
                  ) : null
                }
              />
            </Grid2>
          </Grid2>
        </div>
      </DialogContent>
      {!isViewMode ? (
        <div className="m-2">
          <Grid2 container spacing={2} columns={12}>
            <Grid2 size={{ xs: 6 }}>
              <AppButton
                Type={"reset"}
                OnPress={() => {
                  validation.handleReset();
                  // SetDialogData(null);
                }}
                children={"Reset"}
                Color={"error"}
              />
            </Grid2>
            <Grid2 size={{ xs: 6 }}>
              <AppButton
                Type={"submit"}
                OnPress={() => {
                  if (navigator.onLine) {
                    validation.handleSubmit();
                  } else {
                    showSnackbar(
                      ERROR_MESSAGE.INTERNET_ERROR,
                      SNACKBAR_VARIANT.ERROR
                    );
                  }
                }}
                children={"Create"}
              />
            </Grid2>
          </Grid2>
        </div>
      ) : null}
    </Dialog>
  );
};

export default CreateNewOrUpdateAccountModal;
